import { useQuery } from '@tanstack/react-query'
import { historyServices } from '../historyServices'
import { CryptoHistoryPriceParams } from '../historyTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

export const useFetchCryptoPriceHistory = (params: CryptoHistoryPriceParams) =>
  useQuery({
    queryKey: [QUERY_KEYS.CRYPTO_PRICE_HISTORY, params],
    queryFn: () => historyServices.fetchCryptoPriceHistory(params),
    staleTime: 60 * 60 * 1000, // 1 hour
    enabled: !!params.blockchain && !!params.period,
  })
